'use strict';
import angular from 'angular';
import './widget.executivesummary.directives';
import './widget.executivesummary.services';

angular.module('widget.executivesummary', [
    'widget.executivesummary.directives',
    'widget.executivesummary.services'
]);